var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCircular(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.46444 3.9453L3.12024 8.19434L3.52256 8.70035L8.86677 4.45132L8.46444 3.9453Z",
    fill: "#8F95B2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1751 3.77416L20.361 8.73828L20.7656 8.23409L14.5797 3.26997L14.1751 3.77416Z",
    fill: "#8F95B2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9128 11.1778L18.5879 18.7607L19.206 18.9502L21.5309 11.3673L20.9128 11.1778Z",
    fill: "#8F95B2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.20005 12.7269L5.03333 19.4746L5.62938 19.2243L2.7961 12.4767L2.20005 12.7269Z",
    fill: "#8F95B2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0627 20.2344H8.89099V20.8808H14.0627V20.2344Z",
    fill: "#8F95B2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.95555 5.88668C9.92177 5.88668 10.705 5.10341 10.705 4.13719C10.705 3.17097 9.92177 2.3877 8.95555 2.3877C7.98933 2.3877 7.20605 3.17097 7.20605 4.13719C7.20605 5.10341 7.98933 5.88668 8.95555 5.88668Z",
    fill: "#232F6A",
    stroke: "white",
    strokeWidth: 0.2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4.04246 9.37789C5.00868 9.37789 5.79195 8.59462 5.79195 7.6284C5.79195 6.66218 5.00868 5.87891 4.04246 5.87891C3.07624 5.87891 2.29297 6.66218 2.29297 7.6284C2.29297 8.59462 3.07624 9.37789 4.04246 9.37789Z",
    fill: "#232F6A",
    stroke: "white",
    strokeWidth: 0.2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M2.74949 11.8349C3.71571 11.8349 4.49899 11.0516 4.49899 10.0854C4.49899 9.11921 3.71571 8.33594 2.74949 8.33594C1.78327 8.33594 1 9.11921 1 10.0854C1 11.0516 1.78327 11.8349 2.74949 11.8349Z",
    fill: "#232F6A",
    stroke: "white",
    strokeWidth: 0.2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M2.74949 14.6787C3.71571 14.6787 4.49899 13.8954 4.49899 12.9292C4.49899 11.963 3.71571 11.1797 2.74949 11.1797C1.78327 11.1797 1 11.963 1 12.9292C1 13.8954 1.78327 14.6787 2.74949 14.6787Z",
    fill: "#232F6A",
    stroke: "white",
    strokeWidth: 0.2
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M4.81834 19.4619C5.78456 19.4619 6.56783 18.6786 6.56783 17.7124C6.56783 16.7462 5.78456 15.9629 4.81834 15.9629C3.85212 15.9629 3.06885 16.7462 3.06885 17.7124C3.06885 18.6786 3.85212 19.4619 4.81834 19.4619Z",
    fill: "#232F6A",
    stroke: "white",
    strokeWidth: 0.2
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M6.62828 21.1435C7.5945 21.1435 8.37777 20.3602 8.37777 19.394C8.37777 18.4278 7.5945 17.6445 6.62828 17.6445C5.66206 17.6445 4.87878 18.4278 4.87878 19.394C4.87878 20.3602 5.66206 21.1435 6.62828 21.1435Z",
    fill: "#232F6A",
    stroke: "white",
    strokeWidth: 0.2
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M9.08482 22.1787C10.051 22.1787 10.8343 21.3954 10.8343 20.4292C10.8343 19.463 10.051 18.6797 9.08482 18.6797C8.1186 18.6797 7.33533 19.463 7.33533 20.4292C7.33533 21.3954 8.1186 22.1787 9.08482 22.1787Z",
    fill: "#232F6A",
    stroke: "white",
    strokeWidth: 0.2
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8 5.49899C12.7662 5.49899 13.5495 4.71571 13.5495 3.74949C13.5495 2.78327 12.7662 2 11.8 2C10.8338 2 10.0505 2.78327 10.0505 3.74949C10.0505 4.71571 10.8338 5.49899 11.8 5.49899Z",
    fill: "#232F6A",
    stroke: "white",
    strokeWidth: 0.2
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6444 5.88668C15.6106 5.88668 16.3939 5.10341 16.3939 4.13719C16.3939 3.17097 15.6106 2.3877 14.6444 2.3877C13.6782 2.3877 12.8949 3.17097 12.8949 4.13719C12.8949 5.10341 13.6782 5.88668 14.6444 5.88668Z",
    fill: "#232F6A",
    stroke: "white",
    strokeWidth: 0.2
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5576 9.37789C20.5238 9.37789 21.3071 8.59462 21.3071 7.6284C21.3071 6.66218 20.5238 5.87891 19.5576 5.87891C18.5914 5.87891 17.8081 6.66218 17.8081 7.6284C17.8081 8.59462 18.5914 9.37789 19.5576 9.37789Z",
    fill: "#232F6A",
    stroke: "white",
    strokeWidth: 0.2
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8506 11.8349C21.8168 11.8349 22.6001 11.0516 22.6001 10.0854C22.6001 9.11921 21.8168 8.33594 20.8506 8.33594C19.8843 8.33594 19.1011 9.11921 19.1011 10.0854C19.1011 11.0516 19.8843 11.8349 20.8506 11.8349Z",
    fill: "#232F6A",
    stroke: "white",
    strokeWidth: 0.2
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8506 14.6787C21.8168 14.6787 22.6001 13.8954 22.6001 12.9292C22.6001 11.963 21.8168 11.1797 20.8506 11.1797C19.8843 11.1797 19.1011 11.963 19.1011 12.9292C19.1011 13.8954 19.8843 14.6787 20.8506 14.6787Z",
    fill: "#232F6A",
    stroke: "white",
    strokeWidth: 0.2
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2988 19.4619C20.265 19.4619 21.0483 18.6786 21.0483 17.7124C21.0483 16.7462 20.265 15.9629 19.2988 15.9629C18.3326 15.9629 17.5493 16.7462 17.5493 17.7124C17.5493 18.6786 18.3326 19.4619 19.2988 19.4619Z",
    fill: "#232F6A",
    stroke: "white",
    strokeWidth: 0.2
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3597 21.1435C18.3259 21.1435 19.1092 20.3602 19.1092 19.394C19.1092 18.4278 18.3259 17.6445 17.3597 17.6445C16.3935 17.6445 15.6102 18.4278 15.6102 19.394C15.6102 20.3602 16.3935 21.1435 17.3597 21.1435Z",
    fill: "#232F6A",
    stroke: "white",
    strokeWidth: 0.2
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0325 22.1787C15.9987 22.1787 16.7819 21.3954 16.7819 20.4292C16.7819 19.463 15.9987 18.6797 15.0325 18.6797C14.0662 18.6797 13.283 19.463 13.283 20.4292C13.283 21.3954 14.0662 22.1787 15.0325 22.1787Z",
    fill: "#232F6A",
    stroke: "white",
    strokeWidth: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircular);
export default __webpack_public_path__ + "static/media/circular.81c12b2106924984871e85f00de179e3.svg";
export { ForwardRef as ReactComponent };